import { Injectable } from '@angular/core';
import { RestApi } from '../../auth/rest.api';
import { Observable } from 'rxjs';

@Injectable()
export class WorkingTimeSchemaService {
  private _getBaseCalendarOptions = 'api/WorkingTimeSchema/BaseCalendar';
  private _getBaseCalendar = 'api/WorkingTimeSchema/BaseCalendar';
  private _getWorkingTimeSchema = 'api/WorkingTimeSchema';

  constructor(private _restApi: RestApi) {
  }


  public getWorkingTimeSchema(userId: number): Observable<Array<IWorkingTimeSchema>> {
    return this._restApi.get(`${this._getWorkingTimeSchema}/${userId}`);
  }

  public getBaseCalendar(userId: number): Promise<IBaseCalendar> {
    return this._restApi.get(`${this._getBaseCalendar}/${userId}`).toPromise();
  }

  public getCalendarOptions(): Promise<IBaseCalendar[]> {
    return this._restApi.get(this._getBaseCalendarOptions).toPromise();
  }

  public updateCalendarBaseByUser(idUser: number, idWorkingTimeSchema: number): Promise<any> {
    return this._restApi.put(`${this._getBaseCalendar}/${idUser}/${idWorkingTimeSchema}`, {}).toPromise();
  }

  public updateCustomCalendar(elements: IWorkingTimeSchema[], toDelete: {[key: string]: boolean}): Observable<any> {
    return this._restApi.post(`${this._getWorkingTimeSchema}/batch`, { elements, toDelete });
  }
}
